module.exports = [{"title":"토노베이션","description":"","position":{"lat":35.17665784125602,"lng":129.12537592501636}}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/cities.json
// module id = Kcxh
// module chunks = 1